import styled from 'styled-components'
import { MOBILE_HEADER_HEIGHT, SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { customizeVerticalScrollbarThumbMixin } from 'styles/mixins'

export const AiAvatarTabWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;

  @media screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    height: calc(100dvh - ${MOBILE_HEADER_HEIGHT}px);
  }
`

export const ScrollableContent = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  padding-top: 22px;

  ${customizeVerticalScrollbarThumbMixin()}

  @media screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    padding: 12px;
    padding-bottom: 16px;
  }
`
